module.exports = __webpack_public_path__ + "img/901249038.915766a7.png";